import { useQuery } from '@tanstack/react-query'

import { promotionsApi } from '../../lib'

import type { CmsBlocksData } from '../../lib/apiClient'
import type { CmsBlock } from '../../types'

interface CmsBlocksResult {
  blockData1: CmsBlock | null
  blockData2: CmsBlock | null
  loading: boolean
  error: Error | null
}

/**
 * Hook for fetching CMS blocks
 */
export function useCmsBlocks(): CmsBlocksResult {
  const query = useQuery<CmsBlocksData>({
    queryKey: ['cmsBlocks'],
    queryFn: () => promotionsApi.getCmsBlocks('black_friday_promotii_1', 'black_friday_promotii_2'),
  })

  const blockData1: CmsBlock | null = query.data?.block1?.items[0] ?? null
  const blockData2: CmsBlock | null = query.data?.block2?.items[0] ?? null

  return {
    blockData1,
    blockData2,
    loading: query.isLoading,
    error: query.error,
  }
}
